import React from 'react';
import { Stack, FormControlLabel, Switch, IconButton } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AutoCompleteComponent from '../AutoCompleteComponenet';
import { handleValidateCodevalue } from '../../Utility/constant';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import './ActionablesFilters.css';

const ActionablesFilters = ({
    internationalise,
    ownerDropdown,
    selectedOwner,
    onOwnerChange,
    isDropdownDisabled,
    ownerLabel,
    filters,
    onToggleUnread,
    onToggleProspects,
    showProspectToggle = false,
    isCalendarOpen = false,
    onOpenCalendar
}) => {
    const isMobile = useIsMobile();

    return (
        <Stack className='parentStack actionables-filters' display="flex" flexWrap={"wrap"} flexDirection="row" alignItems="center" gap={3}>
            <AutoCompleteComponent
                className="actionables-filters-autocomplete"
                optionSet={ownerDropdown}
                value={selectedOwner || null}
                name="managerId"
                placeholder={handleValidateCodevalue(internationalise, ownerLabel)}
                disabled={isDropdownDisabled}
                label={handleValidateCodevalue(internationalise, ownerLabel)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={onOwnerChange}
            />

            {(showProspectToggle && !isMobile) && (
                <FormControlLabel
                    control={
                        <Switch
                            checked={filters?.checked || false}
                            disabled={!selectedOwner}
                            onChange={onToggleProspects}
                            name="prospects"
                            color="primary"
                        />
                    }
                    label={handleValidateCodevalue(
                        internationalise,
                        !selectedOwner ? "SELECT_AN_OWNER_FIRST" : "COMMON_SHOW_PROSPECTS"
                    )}
                />
            )}
            {!isMobile && (
                <FormControlLabel
                    control={
                        <Switch
                            checked={filters?.unRead || false}
                            disabled={!selectedOwner}
                            onChange={onToggleUnread}
                            name="unread"
                            color="primary"
                        />
                    }
                    label={handleValidateCodevalue(
                        internationalise,
                        !selectedOwner ? "SELECT_AN_OWNER_FIRST" : "COMMON_SHOW_UNREAD"
                    )}
                />
            )}

            {(!isMobile && onOpenCalendar) && (
                <FormControlLabel
                    className="actionables-calendar-filter"
                    disabled={!selectedOwner}
                    onClick={!selectedOwner ? undefined : onOpenCalendar}
                    control={
                        <IconButton
                            disabled={!selectedOwner}
                            color="primary"
                            size="small"
                            className="actionables-calendar-filter__icon-btn"
                        >
                            <CalendarMonthIcon />
                        </IconButton>
                    }
                    label={handleValidateCodevalue(internationalise, "DB_ACTIONABLES_CAL_VIEW")}
                />
            )}
        </Stack>
    );
};

export default ActionablesFilters;
